<div class="view-container">
  <div class="ranges">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Your ranges</label>
          <button 
            mat-flat-button type="button"
            color="accent"
            (click)="newRange()"
            matTooltip="Add Range">
            <mat-icon>add</mat-icon>Add Range
          </button>
        </div>
        <range-list
          [admin]="admin"
          [company]="company"
          [isDarkMode]="isDarkMode">
        </range-list>
      </mat-card-content>
    </mat-card>
  </div>
</div>
